import './ui/index.css';

import { startTransition, StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './app/App.js';
import { createAppRouter } from './app/router.js';
import { initI18n } from './lib/i18n/index.js';
import { applyMotionPreference } from './ui/motion.js';

applyMotionPreference();
await initI18n();

const root = document.getElementById('root');
if (!root) throw new Error('Missing #root element');

const router = createAppRouter();

// A transition lets React yield while it renders the first page, so the
// main thread is never blocked for long (total blocking time, INP).
startTransition(() => {
  createRoot(root).render(
    <StrictMode>
      <App router={router} />
    </StrictMode>,
  );
});
